import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import AnalyticsPage from '../salesAnalytics/analyticsPage';
import BestSellingItemsPage from '../salesAnalytics/bestSellingItemsPage';
import CategoryAnalysisPage from '../salesAnalytics/categoriesAnalyticsPage';
import SalesPerformanceComparison from '../../components/SalesPerformanceComparison';
import ExportAnalytics from '../../components/ExportAnalytics';
import VegNonVegSales from '../../components/VegNonVegSales';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const AnalyticsSection = ({ isFullscreen = false }) => {
    const navigate = useNavigate();
    const [refreshToken, setRefreshToken] = useState(0);

    const handleRefresh = () => {
        setRefreshToken((prev) => prev + 1);
    };

    return (
        <div className={`${isFullscreen ? 'min-h-screen' : ''} overflow-x-hidden`}>
            <div className="sticky top-0 z-10 bg-white border-b border-stone-200 shadow-sm">
                <div className="px-3 py-1.5 sm:px-4 sm:py-1.5">
                    <div className="flex flex-wrap items-center justify-between gap-1.5">
                        <h2 className="text-base font-bold text-stone-800">Food Analytics</h2>
                        <div className="flex items-center gap-2">
                            <button
                                type="button"
                                onClick={handleRefresh}
                                className="inline-flex items-center justify-center p-2 rounded-lg font-semibold bg-orange-500 text-white hover:bg-orange-600 disabled:opacity-60 transition-colors shadow-sm size-9"
                                title="Refresh"
                                aria-label="Refresh"
                            >
                                <span className="text-sm">↻</span>
                            </button>
                            {!isFullscreen && (
                                <button
                                    type="button"
                                    onClick={() => navigate('/restaurant/analytics-fullscreen')}
                                    className="inline-flex h-7 w-7 items-center justify-center rounded-md border border-stone-200 bg-white text-stone-600 hover:bg-stone-50 transition-colors"
                                    title="Fullscreen"
                                    aria-label="Fullscreen"
                                >
                                    <span className="text-xs">⤢</span>
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="py-3 sm:py-5 px-0 space-y-3">
                <div className="grid gap-3 lg:grid-cols-2">
                    <div className="bg-white rounded-xl border border-stone-200 shadow-sm p-3 sm:p-4">
                        <h3 className="text-[11px] font-semibold text-stone-500 uppercase tracking-wide mb-1.5">Revenue over time</h3>
                        <AnalyticsPage key={`analytics-${refreshToken}`} />
                    </div>
                    <div className="bg-white rounded-xl border border-stone-200 shadow-sm p-3 sm:p-4">
                        <h3 className="text-[11px] font-semibold text-stone-500 uppercase tracking-wide mb-1.5">Veg vs Non-veg sales</h3>
                        <VegNonVegSales key={`veg-${refreshToken}`} />
                    </div>
                </div>

                <div className="grid gap-3 lg:grid-cols-2">
                    <div className="bg-white rounded-xl border border-stone-200 shadow-sm p-3 sm:p-4">
                        <h3 className="text-[11px] font-semibold text-stone-500 uppercase tracking-wide mb-1.5">Best selling items</h3>
                        <BestSellingItemsPage key={`best-${refreshToken}`} />
                    </div>
                    <div className="bg-white rounded-xl border border-stone-200 shadow-sm p-3 sm:p-4">
                        <h3 className="text-[11px] font-semibold text-stone-500 uppercase tracking-wide mb-1.5">Category performance</h3>
                        <CategoryAnalysisPage key={`category-${refreshToken}`} />
                    </div>
                </div>

                <div className="bg-white rounded-xl border border-stone-200 shadow-sm p-3 sm:p-4">
                    <h3 className="text-[11px] font-semibold text-stone-500 uppercase tracking-wide mb-1.5">Sales performance comparison</h3>
                    <SalesPerformanceComparison key={`performance-${refreshToken}`} />
                </div>

                <div className="bg-white rounded-xl border border-stone-200 shadow-sm p-3 sm:p-4">
                    <h3 className="text-[11px] font-semibold text-stone-500 uppercase tracking-wide mb-1.5">Export & reports</h3>
                    <ExportAnalytics key={`export-${refreshToken}`} />
                </div>
            </div>
        </div>
    );
};

export default AnalyticsSection;
